const kidney_questions  = [
   {
      "question":"Does ##name## have any sign or symptoms due to renal dysfunction?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "isAdditional": true,
      "multi":true,
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"Veteran has signs and symptoms due to renal dysfunction i.e ",
      "dbqName_no":"No signs and symptoms of renal dysfunction found in Veteran. ",
      "answer":"",
   },
   {
      "question":"Please indicate all sign or symptoms due to renal dysfunction",
      "sub":"Check all that apply",
      "type":"checkbox",
      "multi": true,
      "small": true,
      "show": false,
      "isAdditional": true,
      "refId":1,
      "cols": 2,
      "questions":[
         {
            "main":"Proteinuria (albuminuria)",
            "dbqName":"",
            "answer":"",
            "multi": true,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Recurring",
                  "dbqName":"",
                  "answer":""
               },
               {
                  "main":"Constant",
                  "dbqName":"",
                  "answer":""
               },
               {
                  "main":"Persistent",
                  "dbqName":"",
                  "answer":""
               }
            ],
         },
         {
            "main":"Edema (due to renal dysfunction)",
            "dbqName":"",
            "answer":"",
            "multi": true,
            "subAnswer":"",
            "textarea": false,
            "showSubItems": false,
            "subItems": [
               {
                  "main":"Some",
                  "dbqName":"",
                  "answer":""
               },
               {
                  "main":"Transient",
                  "dbqName":"",
                  "answer":""
               },
               {
                  "main":"Slight",
                  "dbqName":"",
                  "answer":""
               },
               {
                  "main":"Persistent",
                  "dbqName":"",
                  "answer":""
               },
            ],
         },
         {
            "main":"Anorexia due to renal dysfunction",
            "dbqName":"",
            "answer":""
         },
         {
            "main":"Generalized poor health",
            "dbqName":"",
            "answer":""
         },
         {
            "main":"Lethargy",
            "dbqName":"",
            "answer":""
         },
         {
            "main":"Weakness",
            "dbqName":"",
            "answer":""
         },
         {
            "main":"Limitation of exertion",
            "dbqName":"",
            "answer":""
         },  
         {
            "main":"Able to perform only sedentary activity, due to persistent edema caused by renal dysfunction",
            "dbqName":"",
            "answer":""
         },           
      ],
      "answer":""
   },
   {
      "question":"Does ##name## have Hypertension and/or heart disease due to Renal Dysfunction or caused by any kidney condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "isAdditional": true,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":" Also, suffering from heart disease due to Renal Dysfunction",
      "dbqName_no":" But, no signs are observed regarding Hypertension or heart disease due to Renal Dysfunction.",
      "answer":"",
   },
   {
      "question":"Is the renal tubular disorder symptomatic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "isAdditional": true,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"Renal tubular disorder is symptomatic as well.",
      "dbqName_no":" Renal tubular disorder is not symptomatic.",
      "answer":"",
   },
   {
      "question":"Does ##name## have frequent attacks of colic with infection (pyonephrosis)?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "isAdditional": true,
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":" Veteran is suffering from frequent attacks of colic with infection, here is the detail, ",
      "dbqName_no":" Attacks of colic with infection is not found",
      "answer":"",
   },
   {
      "question":"Indicate severity for attacks of colic with infection",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "show": false,
      "isAdditional": true,
      "small": true,
      "refId":1,
      "cols": 2,
      "questions":[
         {
            "main":"No symptoms or attacks of colic",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Catheter_drainage[0]",
            "answer":""
         },
         {
            "main":"Occasional attacks of colic",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Infection_pyonephrosis[0]",
            "answer":""
         },
         {
            "main":"Frequent attacks of colic",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Impaired_kidney_function[0]",
            "answer":""
         },
         {
            "main":"Causing voiding dysfunction",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Catheter_drainage[0]",
            "answer":""
         },
         {
            "main":"Requires catheter drainage",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Infection_pyonephrosis[0]",
            "answer":""
         },
         {
            "main":"Causing infection",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Impaired_kidney_function[0]",
            "answer":""
         },
         {
            "main":"Causing urolithiasis",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Infection_pyonephrosis[0]",
            "answer":""
         },
         {
            "main":"Causing impaired kidney function",
            "dbqName":"form1[0].Page_3[0].Section_III_Renal_Dysfunction_Subform[0].Impaired_kidney_function[0]",
            "answer":""
         }      
      ],
      "answer":""
   },
 ]

 export default kidney_questions ;
